import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PicText from './picText';
import userkeyUtil from '../../utils/setUserKey';
import RelateNews from '../../components/relateNews';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        isShowRelate: true,
    };

    componentDidMount() {
        this.huaweiPageExp();
        userkeyUtil.init();

        if (location.href.includes('simpleUrl=false')) {
            this.setState({
                isShowRelate: false,
            });
        }
    }

    huaweiPageExp = () => {
        const { content } = this.props;
        const allImages = {};

        if (!content.imagesInContent || (!Array.isArray(content.imagesInContent) && content.imagesInContent.length === 0)) return false;
        content.imagesInContent.forEach((item, index) => {
            allImages[`img_${index}`] = item.url;
        });
        const globalInfo = {
            img: (content.imagesInContent && content.imagesInContent[0] && content.imagesInContent[0].url) || '',
            docid: content.base62Id || '',
            title: content.title || '',
            summary: content.title || '',
            show_imgs: allImages,
        };

        const script = document.createElement('script');

        script.innerHTML = `var globalInfo=${JSON.stringify(globalInfo)}`;
        document.head.appendChild(script);
    };

    render() {
        const { content } = this.props;
        const { isShowRelate } = this.state;
        const relateNewsConfig = {
            moduleName: '推荐阅读',
            docType: 'doc',
            base62Id: content.base62Id,
            title: content.title || '',
            adNews: content.adNews,
        };

        return (
            <Fragment>
                <PicText content={content} />
                {isShowRelate && <RelateNews content={relateNewsConfig} />}
            </Fragment>
        );
    }
}

export default errorBoundary(Layout);
